import { Address, IsAddressOptions, isAddress as _isAddress } from "viem"

export function isAddress(
  address?: string,
  { strict = false, ...options }: IsAddressOptions = { strict: false },
): address is Address {
  return Boolean(address && _isAddress(address, { strict, ...options }))
}
